import { useEffect, useState } from 'react';
import { getArgFromUrl } from '../utils';
export default function useIsEn() {
    var _a = useState(false), isEn = _a[0], setIsEn = _a[1];
    useEffect(function () {
        setIsEn((getArgFromUrl('language') || 'en') !== 'ar');
    }, []);
    return isEn;
}
export function useIsEs() {
    var _a = useState(false), isEs = _a[0], setIsEs = _a[1];
    // 这两个字体差不多，都是一起出问题的
    useEffect(function () {
        setIsEs((getArgFromUrl('language') || 'en') === 'es' || (getArgFromUrl('language') || 'en') === 'pt');
    }, []);
    return isEs;
}
